import axios from 'axios';
import { message } from 'ant-design-vue';
import store from '../store/index';
import router from '../router/index';
const ErrorMsg = {
  400: '请求错误',
  401: '未授权，请登录',
  403: '拒绝访问',
  404: '请求地址出错',
  405: '方法不被允许',
  408: '请求超时',
  500: '服务器错误',
  501: '服务未实现',
  502: '网关错误',
  503: '服务不可用',
  504: '网关超时',
  505: 'HTTP版本不受支持',
};
const proxy = process.env.VUE_APP_QC_PROXY;
axios.defaults.timeout = 5000;
/**
 * http request 拦截器
 */
axios.interceptors.request.use(
  (config) => {
    appendTokenToUrl(config);
    // printRequest(config);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * http response 拦截器
 */
axios.interceptors.response.use(
  (response) => {
    if (response == 'SessionNull' || response.data.code === 3) {
      message.info('登录过期', 1, () => {
        router.replace('login');
      });
    }

    if (response && response.data.code == -1) {
      //接口访问404
      console.log('错误response:', response);
      message.error('请求出错');
    }
    return response;
  },
  (error) => {
    const errTxt = JSON.stringify(error);
    console.log('error', errTxt);
    console.log('401',errTxt.indexOf('401'))
    if (errTxt.indexOf('401') != -1) {
      message.info('登录过期', 1, () => {
        router.replace('login');
      });
      return
    }
    const errMsg = errTxt.indexOf('timeout') != -1 ? '请求超时' : error;
    message.error(`请求出错:${errMsg}`);
  }
);

function requestHttp(requestParams) {
  let { api, method, params = {}, config = {} } = requestParams;
  let apiUrl = `${proxy}${api}`;
  if (!method) {
    message.error('请设置请求类型');
    return;
  }
  //默认系统参数
  let opts = {
    timeout: 30000,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
  };
  Object.assign(opts, config);
  var fd = new FormData();
  for (let item in params) {
    fd.append(`${item}`, params[item]);
  }
  switch (method) {
    case 'GET':
      return new Promise((resolve, reject) => {
        axios
          .get(apiUrl, opts)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    case 'POST':
      return new Promise((resolve, reject) => {
        axios
          .post(apiUrl, fd, opts)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    case 'DELETE':
      return new Promise((resolve, reject) => {
        axios
          .delete(apiUrl, opts)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    case 'PUT':
      return new Promise((resolve, reject) => {
        axios
          .put(apiUrl, fd, opts)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    case 'PATCH':
      return new Promise((resolve, reject) => {
        axios
          .patch(apiUrl, fd, opts)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
  }
}

//拼接token
function appendTokenToUrl(config) {
  if (config.url.indexOf('/login') != -1) {
    return;
  }
  const {
    User: { token },
  } = store.state;
  if (!token) return;
  let symbol = config.url.indexOf('?') == -1 ? '?' : '&';
  config.url += `${symbol}token=${token}`;
}

//打印请求
function printRequest(config) {
  if (process.env.NODE_ENV != 'development') return;
  console.log(`%c请求地址 ==> ${config.url}`, 'color:#65c366');
  console.log(
    `%c请求类型 ==> ${config.method} ${
      config.method == 'get' ? JSON.stringify(config.params) : ''
    }`,
    'color:#65c366'
  );
}

export { requestHttp };
